import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { BonImportInterface } from "../../redux/bonImportTypes";
import { BonImportDetails } from "../show";

type ActionColumnProps = {
  bonImport: BonImportInterface;
};

export const ActionColumn = (props: ActionColumnProps) => {
  const { bonImport } = props;
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState<boolean>(false);

  return (
    <React.Fragment>
      <Dropdown>
        <Dropdown.Toggle
          id="dropdown-action"
          style={{ background: "none", border: "0", color: "#a6b0cf" }}
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            role="button"
            onClick={() => setShowDetails(!showDetails)}
          >
            {t("show_details")}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {showDetails && (
        <BonImportDetails
          show={showDetails}
          onHide={() => setShowDetails(!setShowDetails)}
          bonImport={bonImport}
        />
      )}
    </React.Fragment>
  );
};
